// El plan vivo se actualiza SINCRÓNICAMENTE en un ref y recién después se publica a React
// (review 2026-10-14, punto 1): las herramientas del agente encadenan varias acciones en el
// mismo tick y leen el plan entre medio; con el ref actualizado adentro del updater de React
// (que corre en el render), `leerPlan()` devolvía el plan viejo y el modelo recibía "0 tomas".
import type { PlanDeCatalogo } from './plan';

export type CambioDePlan = PlanDeCatalogo | ((prev: PlanDeCatalogo) => PlanDeCatalogo);

export function actualizarPlanEnRef(
  ref: { current: PlanDeCatalogo | null },
  publicar: (plan: PlanDeCatalogo) => void,
  v: CambioDePlan,
): void {
  const siguiente = typeof v === 'function' ? (ref.current ? v(ref.current) : null) : v;
  if (!siguiente) return;
  ref.current = siguiente;
  publicar(siguiente);
}
